import Select from 'react-select';
import React from 'react';

export default function ReactSelectAdapter({ input, ...rest }) {
  return (<Select {...input} {...rest} searchable />);
}
